import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Card, Flex, Row, Space } from "antd";
import { CardContainer } from "components/elements";
import { MainLayout } from "components/layouts";
import { EmployeeTable } from "components/table";
import { useTranslation } from "react-i18next";
import EmployeeFilter from "./EmployeeFilter";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import styles from "../styles/EmployeeList.module.css";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";
import useHistory from "features/webapp/hook/useHistory";
import { useLocation, useNavigate } from "react-router-dom";
import { current } from "@reduxjs/toolkit";

const EmployeeList = ({
  employeeList = [],
  organizationUnderOptions = [],
  shiftList = [],
  modifiedPositionOptions = [],
  positionOption = [],
  workInLocationOptions = [],
  durationOptions = [],
  shiftDropDown = [],
  supervisorOptions = [],
  employeeTypeOptions = [],
  employmentTypeOptions = [],
  getGender = [],
  employeeStatusTypeOptions = [],
  isLoading = false,
  pagination = {},
  disableButton = false,
  onView = () => { },
  setValuesChange = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  onSubmit = () => { },
  onCancel = () => { },
  setOpenModal = () => { },
  ModalUpload = () => { },
  modalDownload = () => { },
  onClear = () => { },
}) => {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);
  const isDisabled = !roles.includes("CREATE_EMPLOYEE|ADD_EMPLOYEE");
  const history = useHistory()
  const location = useLocation()
  console.log("history", history, location);

  useMemo(() => {
    if (location?.state?.search == 'dashboard') {
      setUseFilter(true)
    }
  },
    [location?.state?.search])
  return (
    <MainLayout>
      <Space className={styles.container} direction="vertical" size={24}>
        <Flex justify="space-between" align="center">
          <Flex vertical>
            <Breadcrumb items={[
              { title: t("home.header"), href: "/" },
              { title: t("employee.header"), href: "" },
              { title: t("employee.all") },
            ]}
              style={{ whiteSpace: 'nowrap' }} />
            <h2>{t("employee.all")}</h2>
          </Flex>

          <Flex gap={10}>
            {ModalUpload()}
            {/* <Button onClick={() => { modalDownload() }} disabled={disableButton}>
              {t('whiteList..download')}
            </Button> */}
            {roles.includes("ACCESS_EMPLOYEE|IMPORT_EMPLOYEE") && (
              <Button type="default" onClick={() => { setOpenModal(true) }} style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}>
                <Flex align="center" justify="center" gap={8}>
                  <ImportIcon />
                  <span>{t('common.import')}</span>
                </Flex>

              </Button>
            )}

            <a href="/employee/create">
              {roles.includes("ACCESS_EMPLOYEE|ADD_EMPLOYEE") &&
                <Button
                  style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: isDisabled ? undefined : "var(--button-color)", padding: "8px 16px" }}
                  type="primary"
                  disabled={isDisabled}
                >
                  <Flex align="center" justify="center" gap={8}>
                    <CreateIcon />
                    <span>{t('holiday.label.add_employee')}</span>
                  </Flex>
                </Button>}
            </a>
          </Flex>
        </Flex>

        <Flex vertical style={{ rowGap: 16 }}>
          <Flex justify="end">
            <Button
              type="default"
              onClick={() => setUseFilter(!useFilter)}
              style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
          </Flex>

          {useFilter && (
            <Card style={{
              borderRadius: "8px",
              backgroundColor: "white",
              border: "1px solid #EAECF0",
              height: "100%",
            }}>
              <EmployeeFilter
                organizationUnderOptions={organizationUnderOptions}
                shiftDropDown={shiftDropDown}
                positionOption={positionOption}
                workInLocationOptions={workInLocationOptions}
                durationOptions={durationOptions}
                supervisorOptions={supervisorOptions}
                employeeTypeOptions={employeeTypeOptions}
                employmentTypeOptions={employmentTypeOptions}
                genderOptions={getGender}
                employeeStatusTypeOptions={employeeStatusTypeOptions}
                onChange={onChange}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onClear={onClear}
                isLoading={isLoading}
              />
            </Card>
          )}
          {/* <CardContainer width="100%" height="fit-content"> */}
          <EmployeeTable
            isLoading={isLoading}
            pagination={pagination}
            employeeList={employeeList}
            onView={onView}
            onEdit={onEdit}
            onDelete={onDelete}
            onChange={onChange}
          />
          {/* </CardContainer> */}
        </Flex>
      </Space>
    </MainLayout>
  );
};

export default EmployeeList;
